import React, { useEffect } from 'react';
import styled from 'styled-components';
import TrueImpactText from 'shared/design-system/base/TrueImpactText';
import { IndicatorSectionKey } from '../../ImpactIndicator/utils';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleCheck } from '@fortawesome/pro-light-svg-icons';
import {
  getPreviousAndNextSectionDetails,
  IndicatorDetailsRoutes,
  SectionIndicators,
  sectionKeyToString,
} from '../utils';
import { COLORS } from 'shared/design-system/settings/variables/Colors';
import { SPACERS } from 'shared/design-system/settings/variables/Spacers';
import TrueImpactAnimation from 'shared/design-system/base/TrueImpactAnimation';

interface NextIndicatorProps {
  selectedIndex: number;
  totalIndicators: number;
  indicators: SectionIndicators;
  selectedSectionKey: IndicatorSectionKey;
  setSelectedIndex: React.Dispatch<React.SetStateAction<number>>;
  setSelectedSectionKey: React.Dispatch<
    React.SetStateAction<IndicatorSectionKey | undefined>
  >;
  setRoute: React.Dispatch<React.SetStateAction<IndicatorDetailsRoutes>>;
}

const StyledDiv = styled.div`
  max-width: 627px;
  .next-indicator-heading {
    margin-left: auto;
    margin-right: auto;
    margin-bottom: ${SPACERS.large};
  }
  .next-indicator-subheading {
    margin-left: auto;
    margin-right: auto;
  }
  .icon {
    margin-bottom: ${SPACERS.medium};
  }
`;

const DURATION = 1500;

const NextIndicator: React.FC<NextIndicatorProps> = ({
  indicators,
  selectedIndex,
  totalIndicators,
  selectedSectionKey,
  setSelectedIndex,
  setSelectedSectionKey,
  setRoute,
}) => {
  const { nextSectionKey, nextIndicator } = getPreviousAndNextSectionDetails(
    indicators,
    selectedSectionKey,
    selectedIndex,
  );

  const handleNext = () => {
    if (nextIndicator) {
      setSelectedIndex(s => s + 1);
      setRoute('forecast');
      return;
    }
    // if (nextSectionKey) {
    //   setSelectedIndex(0);
    //   setSelectedSectionKey(nextSectionKey);
    //   setRoute('forecast');
    //   return;
    // }
    setRoute('completed');
  };

  useEffect(() => {
    window.setTimeout(handleNext, DURATION);
  }, []);

  return (
    <TrueImpactAnimation animationDelay={2}>
      <StyledDiv>
        <FontAwesomeIcon
          size="4x"
          icon={faCircleCheck}
          color={COLORS.success}
          className="icon"
        />
        <TrueImpactText
          variant="heading-page"
          className="next-indicator-heading"
        >
          Nice work!
        </TrueImpactText>
        <TrueImpactText
          variant="body-large"
          className="next-indicator-subheading"
        >
          You’ve now completed{' '}
          <strong>
            {selectedIndex + 1} of {totalIndicators}
          </strong>{' '}
          indicator forecasts for your{' '}
          <strong>{sectionKeyToString(selectedSectionKey)}</strong> stage.
        </TrueImpactText>
      </StyledDiv>
    </TrueImpactAnimation>
  );
};

export default NextIndicator;
